import "./Timeline.css";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";

export const RequestTimeline = (data) => {
  return (
    <div className="order-timeline">
      <Typography sx={{marginBottom: 2}} variant="h6" component="h6">
        Order Status
      </Typography>
      <Timeline align="alternate" className="timelineList">
        {data?.data?.map((item) => {
          return (
            <TimelineItem className="timeline-line">
              <TimelineOppositeContent sx={{display: 'none'}}>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot className="timeLineCompleted" />
                <TimelineConnector className="timeLineCompleted" />
              </TimelineSeparator>
              <TimelineContent>
                <Typography className="timelinestatus">
                  {item?.status}
                </Typography>
                <Typography className="orderRow" color="textSecondary">
                  {dayjs(item?.time).format("YYYY-MM-DD  hh:mm A")}
                </Typography>
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
    </div>
  );
};
